import { render, staticRenderFns } from "./TftGameInfo.vue?vue&type=template&id=64f40dbe&"
import script from "./TftGameInfo.vue?vue&type=script&lang=js&"
export * from "./TftGameInfo.vue?vue&type=script&lang=js&"
import style0 from "./TftGameInfo.vue?vue&type=style&index=0&id=64f40dbe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports